

export const fontList = [
    "Permanent Marker", "Lilita One", "Ga Maamli", "Bodoni Moda SC", "Lobster", "Calistoga", "Pacifico", "Bebas Neue", "Roboto Slab", "Rubik", "Playwrite BE VLG", "Playwrite AR", "Edu AU VIC WA NT Hand"
 ]